import React, { FunctionComponent } from 'react';

import Skeleton from '@gojob/ui-bits/Skeleton';
import Text, { TextProps } from '@gojob/ui-bits/Text';

import useRoundNumber from '@gojob/ui-bits/hooks/useRoundNumber';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import useTranslation from 'src/translations/useTranslation';

export interface WeeklyHoursProps extends TextProps<'span'> {
  loading?: boolean;
  weeklyHours?: number;
}

const WeeklyHours: FunctionComponent<WeeklyHoursProps> = (props) => {
  const { weeklyHours = 0, loading, ...other } = props;

  const { spacing } = useTheme();
  const t = useTranslation();

  const roundedWeeklyHours = useRoundNumber(weeklyHours);

  if (!loading && !roundedWeeklyHours) {
    return null;
  }
  return (
    <Text css={{ lineHeight: 1 }} variant="paragraph" inactive {...other}>
      {loading ? <Skeleton width={spacing(18)} /> : t('{count}_weekly_hours', { count: roundedWeeklyHours })}
    </Text>
  );
};

export default WeeklyHours;
